const state = {
  type: null,
  message: null,
  isAlert: false
};

const actions = {
  success({ commit }, message) {
    commit("success", message);
  },
  error({ commit }, message) {
    commit("error", message);
  },
  clear({ commit }) {
    commit("clear");
  }
};

const mutations = {
  success(state, message) {
    state.type = "success";
    state.message = message;
    state.isAlert = true;
  },
  error(state, message) {
    state.type = "danger";
    state.message = message;
    state.isAlert = true;
  },
  clear(state) {
    state.type = null;
    state.message = null;
    state.isAlert = false;
  }
};

export const alert = {
  namespaced: true,
  state,
  actions,
  mutations
};
